import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

export function useSaveAestheticProcedure(baseUrl) {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback(
    (procedureId, payload) => {
      setSaving(true);
      const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
      const request = procedureId
        ? quarkusApi.put(`${baseUrl}/${procedureId}`, payload, authHeader)
        : quarkusApi.post(baseUrl, payload, authHeader);
      return request.finally(() => setSaving(false));
    },
    [baseUrl],
  );

  return { save, isSaving };
}
